



































































import { ApiEvaluationEvaluateStoreListResponse } from '@/api'
import { BookComponents } from '../../components'
import { defineClassComponent } from '@/hooks'
import { ImagePreview } from 'vant'
import { navigateTo } from '@/router'
import { RequiredDeep } from 'vtils/types'

export default defineClassComponent<{
  value: RequiredDeep<ApiEvaluationEvaluateStoreListResponse>['list'][0]
  showAll: boolean
}>(
  {
    props: ['value', 'showAll'],
    components: BookComponents,
  },
  ({ props }) =>
    class {
      handleCommentClick = () => {
        navigateTo('BookCommentDetail', {
          commentId: props.value.id,
        })
      }

      handleImageClick = (index: number) => {
        ImagePreview({
          images: props.value.evaluatePic,
          startPosition: index,
        })
      }
    },
)
